import app from '../app';

const CianMediaAuthentication = window.CianMediaAuthentication;

app.service(
  'authService',
  function (
    $q,
    $rootScope,
    analyticsService,
    apiService,
    addFormService,
    geoService,
    homeownerService,
    userService,
    commercialOwnerService,
  ) {
    'ngInject';

    this.isLastStepLogin = false;

    this.login = (login, password) => {
      const deferred = $q.defer();

      CianMediaAuthentication.LogOn({
        login,
        password,
        onSuccess: () => {
          analyticsService.successAuthorized();

          this.getUserData()
            .then(() => {
              deferred.resolve();
            })
            .catch(err => {
              deferred.reject(err);
            });
        },
        onError: error => {
          deferred.reject(error);
          $rootScope.$apply();
        },
        onAjaxError: () => {
          deferred.reject();
          $rootScope.$apply();
        },
      });

      return deferred.promise;
    };

    this.register = data => {
      const deferred = $q.defer();

      apiService
        .registerUser(data)
        .then(response => {
          analyticsService.successfulRegistration(
            {
              basic: 'user',
              agent: 'agent',
            }[data.userType],
          );

          CianMediaAuthentication.Authenticate({
            logOnInfo: response.data.logOnInfo,
            login: response.data.login,
            onComplete: () => {
              this.getUserData()
                .then(() => {
                  deferred.resolve();
                })
                .catch(err => {
                  deferred.reject(err);
                });
            },
            onError: error => {
              deferred.reject(error);
              $rootScope.$apply();
            },
            onAjaxError: () => {
              deferred.reject();
              $rootScope.$apply();
            },
          });
        })
        .catch(error => {
          deferred.reject(error);
        });

      return deferred.promise;
    };

    this.getUserData = () => {
      return $q
        .all([
          apiService.getUser(),
          apiService.getUserGeo(),
          apiService.canPublishAsHomeowner({ params: { realtyOfferId: addFormService.ad && addFormService.ad.id } }),
          commercialOwnerService.canPublishAsCommercialOwner(),
        ])
        .then(([userData, geoData, canPublishAsHomeowner, canPublishAsCommercialOwner]) => {
          homeownerService.userCanPublishThisOfferAsHomeowner = canPublishAsHomeowner;
          addFormService.ad.isByHomeowner = canPublishAsHomeowner && addFormService.ad.isByHomeowner;
          commercialOwnerService.changeUserCanPublishAsCommercialOwner(canPublishAsCommercialOwner);

          const user = userData.data.data;
          userService.setUser(user, true);
          analyticsService.authUser(user.cianUserId, user.email);

          const userGeo = geoData.data.data;
          if (userGeo) {
            geoService.setUserGeo(userGeo);
          }
        });
    };
  },
);
